export const MIN_STRENGTH = 1;
export const MAX_STRENGTH = 8;



// WEBPACK FOOTER //
// ./src/constants/index.js